import { isAllowed } from '@hotjar/feature-flags';
import type { Site } from '@hotjar/webapp/domains/common/feature';

export const isSiteOnScaleOrScaleTrial = (site: Site): boolean => {
  const isSiteOnEffectivePlanTrial = site.trial?.active;
  const { effectivePlan } = site;

  if (!effectivePlan) {
    return false;
  }

  const isSiteOnTrialOrBasicOrPlus =
    isSiteOnEffectivePlanTrial || ['basic', 'plus'].includes(effectivePlan);

  if (isAllowed('billing_new_scale', site) && !isAllowed('scale_trial_cohort', site)) {
    return !isSiteOnTrialOrBasicOrPlus && effectivePlan !== 'business';
  }

  return !isSiteOnTrialOrBasicOrPlus;
};
